import { useDispatch, useSelector } from 'react-redux';
import { loginRequest, loginSuccess, logout } from '../store/reducers/authReducer';
import type { LoginSuccessPayload } from '@store/actions/authActions';
import { AppState, AppDispatch } from '../store';
import { useMemo } from 'react';
export const useAuth = () => {
    const dispatch: AppDispatch = useDispatch();
    const auth = useSelector((state: AppState) => state.auth);
    const user = useSelector((state: AppState) => state.user);

    const performLogin = (username: string, password: string) => {
        dispatch(loginRequest({ username, password }));
    };

    const performLoginSso = (authData: LoginSuccessPayload) => {
        dispatch(loginSuccess(authData));
    }

    const performLogout = () => {
        sessionStorage.clear()
        dispatch(logout());
    };

    const routeRole = useMemo(() => {
        return auth?.role === 'student' ? 'student' :
            (auth?.role === 'admin' || auth?.role === 'admin_school') ? 'admin' :
                auth?.role === 'admin_class' ? 'teacher' : null;
    }, [auth?.role]);

    const isAdmin = useMemo(() => {
        return auth?.role === 'admin';
    }, [auth?.role]);

    const isTeacher = useMemo(() => {
        return auth?.role === 'admin_class';
    }, [auth?.role]);

    const isAdminSchool = useMemo(() => {
        return auth?.role === 'admin_school';
    }, [auth?.role]);

    const isStudent = useMemo(() => {
        return auth?.role === 'student';
    }, [auth?.role]);

    return {
        login: performLogin,
        logout: performLogout,
        loginSso: performLoginSso,
        auth,
        user,
        routeRole,
        isAdmin,
        isTeacher,
        isAdminSchool,
        isStudent
    };
};
